<template>
  <div>
    <b-row class="mb-2">
      <b-col>
        <b-button @click="nuevoDetalle" size="xl" variant="secondary">
          Agregar detalle de carga
        </b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div>
          <b-table small :fields="fields" foot-clone :items="items" :per-page="perPage" :current-page="currentPage">
            <template slot="especificaciones" slot-scope="data">
              <b-col cols="12" sm="12" md="12" lg="12">
                <!-- <span v-for="item in data.item.specifications">
                  {{ item.text }} ,
                </span> -->
              </b-col>
            </template>

            <template v-slot:cell(actions)="data">
              <b-col cols="12" sm="12" md="12" lg="12">
                <a href="#" @click.prevent="deleteDetalle(data.item)" title="Eliminar" class="text-danger"
                  ><i class="fa fa-close fa-lg mt-1" style="color: red;"></i
                ></a>
              </b-col>
            </template>

            <template v-slot:cell(total)="data">
              ${{ multiplication(data.item.price_box, data.item.quantity_boxes) }}
            </template>
            <template v-slot:foot()="data"> <span></span> </template>
            <template v-slot:foot(total)="data"> ${{ totalAmount }} </template>
            <template v-slot:foot(pallet_quantity)="data"> {{ total_pallet_quantity }} </template>
            <template v-slot:foot(net_weight)="data"> {{ total_net_weight }} </template>
            <template v-slot:foot(gross_weight)="data"> {{ total_gross_weight }} </template>
            <template v-slot:foot(quantity_boxes)="data"> {{ total_quantity_boxes }} </template>
          </b-table>

          <div class="overflow-auto">
            <div class="mt-3">
              <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                align="left"
                prev-text="Prev"
                next-text="Next"
                hide-goto-end-buttons
              ></b-pagination>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>

    <modalDetalleCarga ref="modalDetalleCarga" :boarding="boarding"></modalDetalleCarga>
  </div>
</template>

<script>
import { bus } from "../../main";
import modalDetalleCarga from "./modalDetalleCarga.vue";
import numeral from "numeral";

export default {
  name: "formDetalleCarga",
  components: {
    modalDetalleCarga
  },
  props: ["boarding"],
  data() {
    return {
      items: this.boarding.shipping_detail,
      total_gross_weight: 0,
      total_net_weight: 0,
      total_quantity_boxes: 0,
      total_pallet_quantity: 0,
      perPage: 5,
      currentPage: 1,
      fields: [
        { key: "product.text", label: "Producto" },
        { key: "variety.text", label: "Variedad" },
        { key: "format.name", label: "Formato" },
        { key: "especificaciones" },
        { key: "pallet_quantity", label: "Numero Pallet", class: "text-right" },
        { key: "quantity_boxes", label: "Cajas", class: "text-right" },
        { key: "price_box", label: "Precio por cajas", class: "text-right" },
        { key: "gross_weight", label: "Kilos Bruto", class: "text-right" },
        { key: "net_weight", label: "Kilos Netos", class: "text-right" },
        { key: "total", class: "text-right" },
        { key: "actions", class: "text-center" }
      ]
    };
  },
  created() {
    bus.$on("calcularDetalle", (nada) => {
      this.total_gross_weight = 0;
      this.total_net_weight = 0;
      this.total_quantity_boxes = 0;
      this.total_pallet_quantity = 0;

      for (var indice in this.boarding.shipping_detail) {
        this.total_gross_weight += parseFloat(this.boarding.shipping_detail[indice].gross_weight);
        this.total_net_weight += parseFloat(this.boarding.shipping_detail[indice].net_weight);
        this.total_quantity_boxes += parseFloat(this.boarding.shipping_detail[indice].quantity_boxes);
        this.total_pallet_quantity += parseFloat(this.boarding.shipping_detail[indice].pallet_quantity);
      }
    });
  },
  mounted() {
    this.loadDataForm();
  },
  methods: {
    multiplication(a, b) {
      let value = numeral(a * b);
      return value.format("0,0.00");
    },
    nuevoDetalle() {
      this.$refs.modalDetalleCarga.modalShown = true;
    },
    deleteDetalle(row) {
      const index = this.boarding.shipping_detail.indexOf(row);
      this.boarding.shipping_detail.splice(index, 1);
      bus.$emit("calcularDetalle");
    },
    loadDataForm() {},

    submit() {}
  },
  computed: {
    totalAmount() {
      let value = this.items.reduce((acc, item) => acc + item.price_box * item.quantity_boxes, 0);
      value = numeral(value);
      return value.format("0,0.00");
    },
    rows() {
      return this.items.length;
    }
  },
  beforeMount() {}
};
</script>

<style scoped></style>
